
import React from 'react';
import AdHero from '@/components/ad-landing/AdHero';
import AdServicesSection from '@/components/ad-landing/AdServicesSection';
import AdLeadForm from '@/components/ad-landing/AdLeadForm';
import AdThinkingSection from '@/components/ad-landing/AdThinkingSection';
import BetaProgramCTA from '@/components/BetaProgramCTA';
import AdFooter from '@/components/ad-landing/AdFooter';
import AdMeta from '@/components/ad-landing/AdMeta';

const AdLanding: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Meta tags for social media sharing */}
      <AdMeta 
        title="Sparkwave AI - Transform Your Business With AI"
        description="Powerful AI solutions to automate processes, enhance customer experiences, and drive business growth."
        imageUrl="/lovable-uploads/2a4ca809-1e4b-4f11-9936-d9e370f05626.png"
      />
      
      <AdHero />
      <AdServicesSection />
      <AdLeadForm />
      <AdThinkingSection />
      <BetaProgramCTA />
      <AdFooter />
    </div>
  );
};

export default AdLanding;
